import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import { handleAuth } from "../Login/Auth";
import { useUserTimezoneFormatter } from "../UserTimezoneDateFormatter/UserTimezoneDateFormatter";
import { JobberAvatar } from "../MuiTable";
import { useAdminDarkMode } from "../../contexts/AdminDarkModeContext";
import "./style.css";

const FooterDetails = ({
  quotesData,
  contractData,
  invoicedata,
  requestData,
  options,
  isDonationMode,
}) => {
  const [DateDecode, setDateDecode] = useState("MM/DD/YYYY");
  const [dateFormat, setDateFormat] = useState("MM/DD/YYYY");
  const { darkMode: adminDark } = useAdminDarkMode();

  // Use timezone-aware date formatter hook
  const formatDateWithUserTimezone = useUserTimezoneFormatter();

  const fetchData = async () => {
    try {
      const res = await handleAuth();
      setDateDecode(res.themes);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handleDateFormat = () => {
      if (DateDecode?.Format) {
        setDateFormat(DateDecode?.Format);
      } else {
        setDateFormat("MM/DD/YYYY");
      }
    };

    handleDateFormat();
  }, [DateDecode]);

  const formatDate = (date) => {
    if (!date) return "";
    return formatDateWithUserTimezone(date, {
      dateFormat: dateFormat,
      includeSeconds: false
    });
  };

  const data = quotesData || contractData || invoicedata;

  const firstName = data?.customerData?.FirstName || data?.customer?.FirstName || "";
  const lastName = data?.customerData?.LastName || data?.customer?.LastName || "";
  const fullName = `${firstName} ${lastName}`.trim();

  /** Match All Invoices / All Contracts / All Quotes tables: hash color from row id, not customer id. */
  const avatarColorSeed =
    invoicedata?.InvoiceId ??
    contractData?.ContractId ??
    quotesData?.QuoteId ??
    data?.InvoiceId ??
    data?.ContractId ??
    data?.QuoteId ??
    data?.customerData?.id ??
    data?.customer?.id ??
    data?.CustomerId ??
    null;

  const createdAtForFooter = data?.updatedAt || data?.createdAt;

  return (
    <Grid>
        <Grid className="d-flex align-items-center">
          <JobberAvatar
            name={fullName || "?"}
            showName={false}
            colorSeed={avatarColorSeed != null ? String(avatarColorSeed) : null}
          />
          <Grid className="mx-2">
            <Typography
              className="mb-0 qdj-activity-timeline-name"
              sx={{
                fontSize: "15px",
                fontWeight: 700,
                color: adminDark ? "#f1f5f9" : "#0f172a",
              }}
            >
              {fullName || "—"}
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                color: adminDark ? "#94a3b8" : "#64748b",
              }}
              className="mb-0"
            >
              Created On: {createdAtForFooter ? formatDate(createdAtForFooter) : "—"}
            </Typography>
          </Grid>
        </Grid>
    </Grid>
  );
};

export default FooterDetails;
